import { Component } from "@angular/core";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { PreviewItemFilterComponent } from "@ponder-shared/tools/filter/preview-item-filter.component";
import { Subscription } from "rxjs";

@Component({
    selector: "filter-bar",
    imports: [PreviewItemFilterComponent],
    templateUrl: "./filter-bar.component.html"
})
export class FilterBarComponent {
    public isVisible: boolean = false;
    private visibilitySub!: Subscription;

    public constructor(private events: EventBroker) {
        this.visibilitySub = events.ui.toggleSortFilterBarEvent.subscribe({
            next: (toggle: boolean) => {
                if (this.isVisible != toggle) {
                    this.isVisible = toggle;
                    this.events.ui.headerSizeChangeEvent.emit();
                }
            }
        });
    }

    public ngOnDestroy() {
        this.visibilitySub.unsubscribe();
    }
}